<template>
  <div>
    <b-form class="form profile-name">
      <b-row>
        <b-col cols="12">
          <b-link @click="handleAddProductModalClick">+ Add Product</b-link
          >&nbsp;&nbsp;|&nbsp;&nbsp;
          <b-link @click="handleAddProductModalClick" :disabled="true"
            >+ Add Discount</b-link
          >
          <br /><br />
          <b-card no-body>
            <b-tabs pills card vertical>
              <b-tab title="Products" active>
                <section-products
                  :publishing="publishing"
                  :resource="resource"
                  :settings="settings"
                  @edit-product="handleEditProduct"
                  @edit-delete="handleDeleteProduct"
                  @add-img-to-product="handleItemForParentProperty"
                />
              </b-tab>
              <b-tab title="Discounts">
                <section-products
                  :publishing="publishing"
                  :resource="resource"
                  :settings="settings"
                  @edit-product="handleEditProduct"
                  @edit-delete="handleDeleteProduct"
                />
              </b-tab>
              <b-tab title="Fulfillments">
                <section-products
                  :publishing="publishing"
                  :resource="resource"
                  :settings="settings"
                  @edit-product="handleEditProduct"
                  @edit-delete="handleDeleteProduct"
                />
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </b-form>
    <add-edit-product-modal
      :ref="productModal"
      :modal-id="productModal"
      @add-product="handleAddProduct"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SectionProducts from "./sections/products";
import AddEditProductModal from "./addEditProductModal";
export default {
  name: "SettingsShop",
  components: {
    SectionProducts,
    AddEditProductModal
  },
  props: {
    publishing: {
      type: Object,
      default: () => {}
    },
    resource: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      productModal: "product-modal",
      inputVideoURLDisabled: false,
      videoURL: ""
    };
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      publishings: "listings/listPublishings"
    }),
    settings() {
      return this.resource && this.resource.data && this.resource.data.settings
        ? this.resource.data.settings
        : null;
    }
  },
  watch: {
    publishings(newVal, oldVal) {
      console.log(`Publishings Old: ${oldVal}`);
      console.log(`New: ${newVal}`);
    },
    publishing(newVal, oldVal) {
      console.log(`Publishing Old: ${oldVal}`);
      console.log(`New: ${newVal}`);
    },
    resource(newVal, oldVal) {
      console.log(`Resource Old: ${oldVal}`);
      console.log(`New: ${newVal}`);
    }
  },
  methods: {
    handleAddProductModalClick() {
      this.$refs[this.productModal].showAdd();
    },
    handleEditProduct(product) {
      console.log(`Edit product ${product}`);
      this.$refs[this.productModal].showEdit(product);
    },
    handleDeleteProduct() {
      this.add = true;
      this.$bvModal.show(this.productModal);
    },
    handleAddProduct(product) {
      console.log(`Product is ${product}`);
      const payload = {
        publishingId: this.publishing.id,
        resourceId: this.resource.toolId, //Make toolId, Id
        propertyName: "products",
        resourceItem: product
      };

      this.$store
        .dispatch("resources/addResourceIntoSettings", payload)
        .then(response => {
          this.add = true;
          this.$bvModal.hide(this.productModal);

          this.$store.dispatch("user/showNotification", {
            title: `Added ${payload.name}`,
            description: "",
            variant: "success"
          });

          this.$emit("added-resource-item");
        });
    },
    handleItemForParentProperty(
      propertyName,
      item,
      parentPropertyName,
      parentPropertyId
    ) {
      console.log(`Property: ${propertyName} and Item: ${item}`);
      console.log(
        `Parent Property: ${parentPropertyName} and Id: ${parentPropertyId}`
      );

      const payload = {
        publishingId: this.publishing.id,
        resourceId: this.resource.toolId, //Make toolId, Id
        parentPropertyName: parentPropertyName,
        parentPropertyId: parentPropertyId,
        propertyName: propertyName,
        resourceItem: item
      };

      this.$store
        .dispatch("resources/addResourceIntoSettingsParentProperty", payload)
        .then(response => {
          this.add = true;
          this.$bvModal.hide(this.productModal);

          this.$store.dispatch("user/showNotification", {
            title: `Added ${payload.name}`,
            description: "",
            variant: "success"
          });

          this.$emit("added-resource-item");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  // justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;

  .notification-content {
    margin-left: 14px;
    cursor: pointer;
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;

      color: #8d99a0;
      margin: 0;
    }
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;

      display: flex;
      align-items: center;
      color: #474d52;
      @media (max-width: 874px) {
        margin-bottom: 0px;
      }
    }
  }
  .toggler {
    @media (max-width: 874px) {
      margin-bottom: 10px;
      margin-left: 15px;
    }
    position: relative;
    display: inline-block;
    width: 46.5px;
    height: 24px;
    background: #f3f6f9;
    border-radius: 18px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  .slider {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background: #b3c2cb;
    box-shadow: 0px 3px 9px #c4c4c4;

    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
  .bg {
    background: rgba(85, 126, 251, 0.1);
  }
  .btns {
    left: 50%;
    background: var(--theme-color);
    box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
  }
}
</style>
